(() => {
  const config = JSON.parse(document.getElementById('xh-commerce-config').textContent);
  const root = config.root;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:state?.currency || config.currency}).format(cents / 100);
  let state = null;
  let busy = false;
  let queue = Promise.resolve();
  const byId = id => document.getElementById(id);
  function error(message) {
    let node = byId('xh-cart-error');
    if (!node && byId('cart-items')) {
      node = document.createElement('p');
      node.id = 'xh-cart-error';
      node.setAttribute('role','alert');
      byId('cart-items').before(node);
    }
    if (node) node.textContent = message;
  }
  function render() {
    if (!state || !byId('cart-items')) return;
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = state.item_count);
    byId('cart-title-count').textContent = `(${state.item_count})`;
    byId('cart-items').innerHTML = state.items.length ? state.items.map(item => `<article class="cart-item">${item.image ? `<img src="${escape(item.image)}" alt="${escape(item.product_title)}" width="76" height="90">` : ''}<div><p class="xh-product-name">${escape(item.product_title)}</p><p>${escape(item.variant_title)}</p><strong>${money(item.final_line_price)}</strong><div><div class="quantity"><button data-quantity="${escape(item.key)}" data-change="-1" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button data-quantity="${escape(item.key)}" data-change="1" aria-label="Increase quantity">+</button></div><button class="remove-item" data-remove="${escape(item.key)}">${escape(config.remove)}</button></div></div></article>`).join('') : `<div class="empty-cart"><h3>${escape(config.empty)}</h3><a class="button primary" href="${escape(config.collectionUrl)}">${escape(config.shop)}</a></div>`;
    byId('cart-summary').innerHTML = state.items.length ? `<div class="cart-total"><span>${escape(config.subtotal)}</span><span>${money(state.total_price)}</span></div><p class="fine-print">${escape(config.checkoutNote)}</p><button class="button primary checkout-button" data-checkout>${escape(config.checkout)} →</button>` : '';
    lock();
  }
  function lock() {
    document.querySelectorAll('[data-add],[data-quantity],[data-remove],[data-checkout],#pdp-add,#sticky-add').forEach(el => {
      el.disabled = busy || (el.hasAttribute('data-checkout') && !state?.item_count) || el.dataset.unavailable === 'true';
    });
    byId('cart-dialog')?.setAttribute('aria-busy', String(busy));
  }
  async function request(path, payload) {
    const response = await fetch(root + path, {credentials:'same-origin',cache:'no-store',...(payload ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)} : {})});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || config.error);
    return result;
  }
  function refresh() {
    const task = queue.then(async () => { state = await request('cart.js'); render(); });
    queue = task.catch(() => {});
    return task;
  }
  function mutate(path, payload) {
    const task = queue.then(async () => {
      busy = true; lock(); error('');
      try {
        const result = await request(path, payload);
        state = path === 'cart/change.js' ? result : await request('cart.js');
        render();
      } catch (failure) {
        try { state = await request('cart.js'); render(); } catch {}
        error(failure.message || config.error);
        throw failure;
      } finally { busy = false; lock(); }
    });
    queue = task.catch(() => {});
    return task;
  }
  window.XHCart = {
    config,
    refresh,
    add(id, quantity = 1) {
      const product = config.products.find(p => p.id === id);
      if (!product?.available) { error(config.unavailable); return Promise.reject(new Error(config.unavailable)); }
      return mutate('cart/add.js', {items:[{id:product.variantId,quantity}]});
    },
    change(key, difference) {
      const item = state?.items.find(i => i.key === key);
      if (!item) return refresh();
      return mutate('cart/change.js', {id:key,quantity:Math.max(0,item.quantity + difference)});
    },
    remove(key) { return mutate('cart/change.js', {id:key,quantity:0}); },
    checkout() { if (!busy && state?.item_count) location.assign(root + 'checkout'); },
    render
  };
  addEventListener('pageshow', () => refresh().catch(() => error(config.error)));
  refresh().catch(() => error(config.error));
})();
